import r from "./_tagTester.js";
import t from "./isFunction.js";
import i from "./isArrayBuffer.js";
import { hasStringTagBug as o } from "./_stringTagBug.js";
var a = r("DataView"),
  e = o ? function (r) {
    return null != r && t(r.getInt8) && i(r.buffer);
  } : a;
export { e as default };